import CircularProgress from '@mui/material/CircularProgress';

export const NoddiCircularLoader = ({ classname, loadingText }: { classname?: string; loadingText?: string }) => (
  <div className={`flex flex-col items-center justify-center gap-4 ${classname}`}>
    <CircularProgress className='text-darkPurple' />
    <span>{`${loadingText ?? 'Loading'}...`}</span>
  </div>
);
